import React, { useEffect, useMemo, useState } from "react";
import { clone } from "@formily/shared";
import { createForm } from "@formily/core";
import { createSchemaField, useExpressionScope, observer  } from "@formily/react";
import { requestIdle } from "@designable/shared";
import { CheckCircleOutlined, CloseCircleOutlined } from "@ant-design/icons";
import {
  Form,
  FormItem,
  ArrayCollapse,
  ArrayTable,
  Input,
  Switch,
  Select,
  Space,
  Radio,
} from "@formily/antd";
import { Button, Switch as AntdSwitch } from "antd";
//@ts-ignore
import Modal from "@/components/Modal/Modal";
import { IReaction } from "@/pages/MainPage/frames/Formily/src/setters/components/ReactionsSetter/types";
import cls from "classnames";
import SingleAction from '../ClickEventSetter/SingleAction'
import "./styles.less";
import SingleCase from "../ClickEventSetter/SingleCase";
export interface IVisibleControlSetterProps {
  value?: any;
  onChange?: (value: IReaction) => void;
  exclude?: string[];
  senceType?: string;
  hideClick?: boolean;
  showEnable?: boolean;
}

const SchemaField = createSchemaField({
  components: {
    Form,
    FormItem,
    ArrayCollapse,
    ArrayTable,
    Input,
    Switch,
    Select,
    Space,
    Radio,
  },
});

const actionList = [
  { label: "删除气泡确认框", value: "del" },
  { label: "打开弹窗", value: "modal" },
  { label: "跳转界面视图", value: "page" },
  { label: "打开超链接", value: "link" },
  { label: "全局提示", value: "message" }
];

const senceObj = {
  button: ["del"],
  modal: ["del", "modal"],
  table: [],
};

export const VisibleControlSetter: React.FC<IVisibleControlSetterProps> = (props) => {
  const { exclude, senceType, hideClick, showEnable = false } = props;
  const excludes = exclude || senceObj[senceType] || [];
  const actionTypeList = actionList.filter(
    (item) => !excludes.includes(item.value)
  );
  const [modalVisible, setModalVisible] = useState(false);
  const [innerVisible, setInnerVisible] = useState(false);
  const $scope = useExpressionScope();
  let copyVal:any = props.value;
  useEffect(() => {
    if (modalVisible) {
      requestIdle(
        () => {
          setInnerVisible(true);
        },
        {
          timeout: 100,
        }
      );
    } else {
      setInnerVisible(false);
    }
  }, [modalVisible]);
  const form = useMemo(() => {
    return createForm({
      values: {
        ...copyVal,
      },
    });
  }, [modalVisible, props.value]);
 
  const openModal = () => setModalVisible(true);
  const closeModal = () => setModalVisible(false);

  const edited = copyVal?.actionType || copyVal?.defaultAction?.actionType || (copyVal?.enableCase && copyVal?.caseAction)

  return (
    <>
      <div style={{ width: "100%", display: "flex" }}>
        <Button
          //@ts-ignore
          className={cls({
            "dn-btn-suc": edited,
          })}
          style={{ flex: 1 }}
          onClick={openModal}
          disabled={hideClick || $scope.isTemplate}
        >
          {$scope.isTemplate
            ? "模板禁用"
            : edited
            ? "重新配置"
            : "配置控制逻辑"}
        </Button>
        {edited && (
          <Button
            style={{ width: "32px", borderLeft: "none", color: "#FF7875" }}
            onClick={() => props.onChange(undefined)}
            //@ts-ignore
            icon={<CloseCircleOutlined />}
          ></Button>
        )}
      </div>
      <Modal
        title="配置控制逻辑"
        width={740}
        style={{ top: 20 }}
        bodyStyle={{
          overflow: "auto",
          display: "flex",
          flexDirection: "column",
          maxHeight: "calc(80vh - 100px)",
          minHeight: 546,
          background: "#fff",
          padding: "16px 24px 0",
        }}
        centered
        transitionName=""
        maskTransitionName=""
        open={modalVisible}
        onCancel={closeModal}
        destroyOnClose
        onOk={() => {
          form.validate().then(() => {
            form.submit((values) => {
              props.onChange?.(values);
            });
            closeModal();
          });
        }}
      >
        {innerVisible && (
          <Form
            className="mb12 pt20"
            form={form}
            layout={"vertical"}
            labelCol={6}
            wrapperCol={14}
          >
            <SchemaField scope={{ ...$scope }}>
              
              <SchemaField.Array
                name="caseAction"
                x-decorator="FormItem"
                x-component="ArrayCollapse"
                x-component-props={{
                  // accordion: true,
                }}
              >
                {/* @ts-ignore */}
                <SchemaField.Object
                  x-component="ArrayCollapse.CollapsePanel"
                  x-component-props={{
                    header: "隐藏条件",
                  }}
                >
                  <SchemaField.Void x-component="ArrayCollapse.Index" />
                  <SchemaField.Array
                    name="caseDetail"
                    title="条件"
                    default={[{ propetry: 'value'}]}
                    // x-decorator="FormItem"
                    x-component="ArrayTable"
                  >
                    <SingleCase />
                  </SchemaField.Array>
                  
                  <SchemaField.Void
                    x-component="ArrayCollapse.Remove"
                    x-reactions={{
                      dependencies: ['...caseAction'],
                      fulfill: {
                        state: {
                          "hidden":  '{{$deps[0].length == 1 }}'
                        },
                      }
                    }}
                  />
                  <SchemaField.Void x-component="ArrayCollapse.MoveUp" />
                  <SchemaField.Void x-component="ArrayCollapse.MoveDown" />
                </SchemaField.Object>

                <SchemaField.Void
                  x-component="ArrayCollapse.Addition"
                  title="添加隐藏条件"
                  x-reactions={{
                    dependencies: ['..caseAction'],
                    fulfill: {
                      schema: {
                        "x-visible":  '{{$deps[0].length < 3 }}'
                      },
                    }
                  }}
                />
              </SchemaField.Array>
              {/* <SchemaField.Void
                name={"caseAction"}
                x-component={CaseAction}
                x-component-props={{
                  actionTypeList,
                }}
                x-reactions={{
                  dependencies: ['.enableCase'],
                  fulfill: {
                    schema: {
                      "x-visible":  '{{!!$deps[0]}}'
                    },
                  }
                }}
              /> */}

              {/* <SingleAction
                $scope={{ ...$scope }}
                actionTypeList={actionTypeList}
              /> */}
            </SchemaField>
          </Form>
        )}
      </Modal>
    </>
  );
}